import {
  faFileInvoice,
  faFlag,
  faHotel,
  faLocationDot,
  faStar,
  faTags,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { SitewideResultTypeEnum } from "@search/api/enums";

import { errorMessagesProxy } from "@/utils/helpers";

export const SEARCH_ERRORS = errorMessagesProxy({
  GENERIC_ERROR: "Sorry, there has been a problem with your search.",
});

export const EMPTY_COUNTS = {
  boardBasis: [],
  bookOnline: 0,
  extraYards: 0,
  fourBall: 0,
  nights: [],
  onlineExclusive: 0,
  price: { min: 0, max: 0 },
  reviews: 0,
  rounds: [],
  topPicks: 0,
  tours: 0,
  transportation: { eurotunnel: 0, flights: 0 },
};

export const FILTER_CONTEXTS = {
  available_book_online: "available_book_online",
  eurotunnel: "eurotunnel",
  extra_yards: "extra_yards",
  flights: "flights",
  four_ball: "four_ball",
  nights: "nights",
  online_exclusive: "online_exclusive",
  price: "price",
  reviews: "reviews",
  rounds: "rounds",
  sort: "sort",
  top_picks: "top_picks",
  tours: "tours",
};

export const DEFAULT_LABEL_ICON = faStar;
export const LABEL_ICONS = {
  "airport-transfers-included": faTags,
  "buggies-included": faFlag,
  "free-places-for-groups": faUser,
  "golf-transfers-included": faTags,
  "group-of-2": faUser,
  "group-of-3": faUser,
  "group-of-4": faUser,
  "group-of-5": faUser,
  "group-of-6": faUser,
  "group-of-7": faUser,
  "group-of-8": faUser,
  "trollies-included": faFlag,
};

export const SITEWIDE_RESULT_ICON = {
  [SitewideResultTypeEnum.CONTENT]: faFileInvoice,
  [SitewideResultTypeEnum.PLACE]: faLocationDot,
  [SitewideResultTypeEnum.REGION]: faLocationDot,
  [SitewideResultTypeEnum.VENUE]: faHotel,
};
